import React from "react";


function Loader() {
    return (
        <div className="mt-8">
            <div className="loader mx-auto"/>
        </div>
    );
}

export default Loader;
